import { anchorPoint, sideOf, type Point, type Side } from '@os/engine';
import type { WorldBox } from './graph';
import type { ConnectorEnd } from './schema';

/**
 * World point of a connector end: on its target's anchor; a target hidden in a collapsed section lends the anchor to
 * its closest shown ancestor; else (deleted, never attached) the stored point. The side is known only for unrotated
 * targets.
 */
export function resolveEnd(
  end: ConnectorEnd,
  world: ReadonlyMap<string, WorldBox>,
  hidden: ReadonlySet<string>,
  parent: ReadonlyMap<string, string | null> = new Map(),
): { p: Point; side: Side | null; attached: boolean } {
  let target = end.objectId;
  while (target !== null && hidden.has(target)) target = parent.get(target) ?? null;
  const w = target !== null && end.anchor ? world.get(target) : undefined;
  if (!w || !end.anchor) return { p: { x: end.x, y: end.y }, side: null, attached: false };
  const obb = { cx: w.x + w.w / 2, cy: w.y + w.h / 2, w: w.w, h: w.h, rotation: w.rotation };
  return { p: anchorPoint(obb, end.anchor), side: w.rotation % 360 === 0 ? sideOf(end.anchor) : null, attached: true };
}
